import React from 'react'
import {
  Box, Button, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Typography
} from '@mui/material'
import { router, usePage } from '@inertiajs/react'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'
import FormattedCurrency from '../../../../components/ui/FormattedCurrency'
import StatusBadge from '../../../../components/ui/StatusBadge'

Index.layout = (page) => <AppShell>{page}</AppShell>

const STATUS_FILTERS = [
  { value: '', label: 'Alle' },
  { value: 'draft', label: 'Entwurf' },
  { value: 'submitted', label: 'Eingereicht' },
  { value: 'under_review', label: 'In Prüfung' },
  { value: 'approved', label: 'Freigegeben' },
  { value: 'paid', label: 'Bezahlt' },
  { value: 'rejected', label: 'Abgelehnt' },
]

export default function Index({ property, invoices = [], filters = {} }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/properties/${property.id}`
  const current = filters.status || ''

  const goTo = (status) => {
    const qs = status ? `?status=${status}` : ''
    router.visit(`${basePath}/invoices${qs}`)
  }

  return (
    <Box>
      <PageHeader
        title="Rechnungen"
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: 'Rechnungen' },
        ]}
        actions={
          <Button variant="contained" size="small"
            onClick={() => router.visit(`${basePath}/invoices/new`)}
            data-testid="new-invoice-btn"
          >
            Neue Rechnung
          </Button>
        }
      />

      <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
        {STATUS_FILTERS.map((f) => (
          <Button key={f.value || 'all'} variant="outlined" size="small"
            color={current === f.value ? 'primary' : 'inherit'}
            onClick={() => goTo(f.value)}
            data-testid={`filter-${f.value || 'all'}`}
          >
            {f.label}
          </Button>
        ))}
      </Box>

      <TableContainer component={Paper} elevation={0}
        sx={{ border: '1px solid', borderColor: 'divider' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'background.subtle' }}>
              <TableCell sx={{ fontWeight: 600 }}>Rechnungsnr.</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Datum</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Lieferant</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Kostenart</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Brutto</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Fällig</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {invoices.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                  <Typography color="text.secondary">Keine Rechnungen vorhanden.</Typography>
                </TableCell>
              </TableRow>
            )}
            {invoices.map((i) => (
              <TableRow key={i.id} hover sx={{ cursor: 'pointer' }}
                onClick={() => router.visit(`${basePath}/invoices/${i.id}`)}
                data-testid={`invoice-row-${i.id}`}
              >
                <TableCell>{i.invoice_number}</TableCell>
                <TableCell>{i.invoice_date}</TableCell>
                <TableCell>{i.vendor_name || '—'}</TableCell>
                <TableCell>{i.cost_category_name || '—'}</TableCell>
                <TableCell align="right"><FormattedCurrency value={i.gross_amount} /></TableCell>
                <TableCell>{i.due_date}</TableCell>
                <TableCell>
                  <StatusBadge type="invoice_status" value={i.status} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
